import React, { useState, useEffect, useRef } from "react";
import CompanyTable from "./CompanyTable";
import CreateNewSupplierForm from "./CreateNewSupplierForm";
import Overlay from "../../UILibrary/Overlay";
import { useSelector, useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import "../Dashboard.css";
import {
  setFolders,
  getSuppliersByFolder,
  editFolderName,
  deleteFolder,
  getAllSuppliers,
  getSavedSuppliers
} from "../../../store/suppliersManagementSlice";

const Suppliers = ({
  isNewSupplierClicked,
  setNewSupplierClicked,
  title,
  tabs,
  onTabChange,
  selectedTab,
}) => {
  const popupContainerRef = useRef(null);
  const createSupplierRef = useRef(null);
  const editSupplierRef = useRef(null);
  const [editableCompany, setEditableCompany] = useState(null);
  const [isSupplierCreated, setSupplierCreated] = useState(false);
  const [isSupplierUpdated, setSupplierUpdated] = useState(false);
  const [isEditableSupplier, setEditableSupplier] = useState(false);
  const [isAllSuppliersActive, setAllSuppliersActive] = useState(false);
  const [isEditPopup, setEditPopup] = useState(false);
  const dispatch = useDispatch();
  const folders = useSelector((state) => state.suppliers?.folders);
  const suppliers = useSelector((state) => state.suppliers.suppliers);
  const [pendingSuppliers, setPendingSuppliers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [tempFolderName, setTempFolderName] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingFolderId, setEditingFolderId] = useState(null);
  const [isDeleteTriggered, setDeleteTriggered] = useState(false);
  const userId = useSelector((state) => state.auth.id);
  const user = useSelector((state) => state.auth.userDetails.userDetails);

  const [selectedFolderName, setSelectedFolderName] =
    useState("Total Suppliers");
  const [isFiltered, setFiltered] = useState(false);

  const handleFolderSelection = (folder) => {
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;
    setSelectedFolderName(folder);
    setFiltered(true);
    if (folder !== "Total Suppliers") {
      dispatch(getSuppliersByFolder({ folderName: folder, buyerId: buyerIdToUse }));
    }
  };


  const handleSubmitFolder = () => {
    if (newFolderName.trim() === "") return;

    if (isEditMode && editingFolderId !== null) {
      const updatedFolders = folders.map((folder, index) =>
        index === editingFolderId ? { ...folder, name: newFolderName } : folder
      );
      dispatch(setFolders(updatedFolders));
    } else {
      dispatch(
        setFolders([
          ...folders,
          {
            name: newFolderName,
            numberOfSuppliers: 0,
          },
        ])
      );
    }
    setShowModal(false);
    setNewFolderName("");
    setIsEditMode(false);
    setEditingFolderId(null);
  };

  const newSupplier = {
    _id: uuidv4(),
    company: {
      name: "",
      description: "",
      dba: "",
      website: "",
      businessSize: {
        class: "",
        class_type: "",
        min: "",
        max: "",
        currency: "",
        value: "",
        operator: "",
      },
      employeeRange: {
        min: "",
        max: "",
        value: "",
        operator: "",
      },
    },
    identifiers: {
      identifierDetails: [
        {
          name: "",
          description: "Tax ID / EIN",
          code: "",
          type: "Tax ID / EIN",
        },
        {
          name: "",
          description: "DUNS number",
          code: "",
          type: "DUNS",
        },
      ],
    },
    socialMedia: [],
    contact: {
      type: [
        {
          identifier: "primary",
          Salutation: "",
          name: {
            firstName: "",
            lastName: "",
            middleName: "",
          },
          gender: "",
          ethnicity: "",
          title: "",
          email: "",
          phoneAreaCode: "",
          phoneNumber: "",
          phoneExtn: "",
          faxAreaCode: "",
          faxNumber: "",
          tollFreePhoneAreaCode: "",
          tollFreePhoneNumber: "",
          tollFreePhoneExtn: "",
        },
      ],
    },
    address: {
      type: [
        {
          identifier: "physical",
          country: "",
          state: "",
          city: "",
          street: "",
          misc: "",
          address_line_01: "",
          address_line_02: "",
          address_line_03: "",
          postalCode: "",
          division: "",
          zip_01: "",
          zip_02: "",
          Latitude: "",
          Longitude: "",
        },
      ],
    },
    diversity: {
      certificationType: [],
      agency: {
        details: [
          {
            name: "",
            isCertified: "",
            description: "",
          },
        ],
      },
    },
    capability: {
      capabilityDetails: [],
    },
    industry: {
      name: "",
      code: "",
      description: "",
      tag: "",
    },
    services: {
      servicesDetails: [],
    },
    commodityCode: {
      ccDetails: [],
    },
    goods: {
      goodDetails: [],
    },
    folder: {
      name: "",
      numberOfSuppliers: "",
    },
  };

  const handleEdit = (supplier) => {
    const editableSupplierData = {
      _id: supplier._id,
      company: {
        name: supplier?.company?.name || "",
        description: supplier?.company?.description || "",
        dba: supplier?.company?.dba || "",
        website: supplier?.company?.website || "",
        businessSize: {
          class: supplier?.company?.businessSize?.class || "",
          class_type: supplier?.company?.businessSize?.class_type || "",
          min: supplier?.company?.businessSize?.min || "",
          max: supplier?.company?.businessSize?.max || "",
          currency: supplier?.company?.businessSize?.currency || "",
          value: supplier?.company?.businessSize?.value || "",
          operator: supplier?.company?.businessSize?.operator || "",
        },
        employeeRange: {
          min: supplier?.company?.employeeRange?.min || "",
          max: supplier?.company?.employeeRange?.max || "",
          value: supplier?.company?.employeeRange?.value || "",
          operator: supplier?.company?.employeeRange?.operator || "",
        },
      },
      identifiers: {
        identifierDetails: supplier?.identifiers?.identifierDetails ||
          supplier?.identifiers?.identiferDetails ||
          [],
      },
      socialMedia: supplier?.socialMedia || [],
      contact: {
        type: supplier?.contact?.type || [],
      },
      address: {
        type: supplier?.address?.type || [],
      },
      diversity: {
        certificationType: supplier?.diversity?.certificationType || [],
        agency: {
          details: supplier?.diversity?.agency?.details || [],
        },
      },
      capability: {
        capabilityDetails: supplier?.capability?.capabilityDetails || [],
      },
      industry: {
        name: supplier?.industry?.name || "",
        description: supplier?.industry?.description || "",
        tag: supplier?.industry?.tag || "",
      },
      services: {
        servicesDetails: supplier?.services?.servicesDetails || [],
      },
      commodityCode: {
        ccDetails: supplier?.commodityCode?.ccDetails || [],
      },
      goods: {
        goodDetails: supplier?.goods?.goodDetails || [],
      },
      folder: {
        name: (() => {
          const raw = supplier?.addToFolder ?? supplier?.folder ?? "";
          if (typeof raw === "string") return raw;
          if (Array.isArray(raw)) {
            const first = raw.find((x) => x != null && x !== "");
            if (typeof first === "string") return first;
            if (first && typeof first === "object") {
              return first.name || first.folderName || "";
            }
            return "";
          }
          if (raw && typeof raw === "object") {
            return raw.name || raw.folderName || "";
          }
          return "";
        })(),
        numberOfSuppliers: supplier?.folder?.numberOfSuppliers || "",
      },
    };


    setEditableSupplier(true);
    setNewSupplierClicked(true);
    setEditableCompany(editableSupplierData);
  };

  const handleEditFolder = (folder, index) => {
    setTempFolderName(folder.name);
    setNewFolderName(folder.name);
    setEditingFolderId(folder.id || index);
    setIsEditMode(true);
    setShowModal(true);

  };

  const handleConfirmEditFolder = () => {
    const buyerIdToUse = user?.isTestUser ? user?.id : userId;
     dispatch(
      editFolderName({
        folderToEdit: tempFolderName,
        newFolderName,
        buyerId: buyerIdToUse
      })
    );
    setIsEditMode(false);
    setShowModal(false);
    setNewFolderName("");
    setTempFolderName("");
  };

  const handleDeleteFolder = () => {
    setDeleteTriggered(true);
  };
  const buyerIdToUse = user?.isTestUser ? user?.id : userId;
  const confirmDelete = async () => {
    try {
      await dispatch(
        deleteFolder({ folderName: tempFolderName, buyerId: buyerIdToUse })
      );
      dispatch(getAllSuppliers({ page: 1, limit: 50, buyerId: buyerIdToUse }));
    } catch (error) {
      console.error("Error deleting folder or fetching suppliers:", error);
    }
    setDeleteTriggered(false);
    setIsEditMode(false);
    setShowModal(false);
    setNewFolderName("");
    setTempFolderName("");
  };

  const handleClickOutside = (event) => {
    if (
      (popupContainerRef.current &&
        !popupContainerRef.current.contains(event.target)) ||
      (createSupplierRef.current &&
        !createSupplierRef.current.contains(event.target)) ||
      (editSupplierRef.current &&
        !editSupplierRef.current.contains(event.target))
    ) {
      setNewSupplierClicked(false);
      setEditableCompany(null);
      setEditableSupplier(false);
      setEditPopup(false);
      setSupplierCreated(false);
    }
  };
  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh" }}>
      <div>
        <div className="flex gap-4 flex-wrap">
          {folders.length === 0 ? (
            <div
              onClick={() => setShowModal(true)}
              className="flex w-[221px] h-[97px] p-[9px_0px_12px_11px] flex-col justify-center items-start gap-2 m-[10px] rounded-[8px] border border-[#ebebeb] bg-white shadow-[0px_3px_0px_0px_rgba(0,0,0,0.1)]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
              >
                <path
                  d="M14.625 21.375C14.625 21.7575 14.67 22.1287 14.7262 22.5H4.5C3.90326 22.5 3.33097 22.2629 2.90901 21.841C2.48705 21.419 2.25 20.8467 2.25 20.25V6.75C2.25 5.50125 3.25125 4.5 4.5 4.5H11.25L13.5 6.75H22.5C23.0967 6.75 23.669 6.98705 24.091 7.40901C24.5129 7.83097 24.75 8.40326 24.75 9V15.5363C24.0637 15.1425 23.31 14.8725 22.5 14.7262V9H4.5V20.25H14.7262C14.67 20.6213 14.625 20.9925 14.625 21.375ZM22.5 20.25V16.875H20.25V20.25H16.875V22.5H20.25V25.875H22.5V22.5H25.875V20.25H22.5Z"
                  fill="#7B7B7B"
                />
              </svg>
              <span className="font-medium text-base text-[#7B7B7B]">
                Add a new folder
              </span>
            </div>
          ) : (
            <>
              {folders.map((folder, index) => (
                <div
                  key={index}
                  onClick={() => handleFolderSelection(folder.name)}
                  className="cursor-pointer relative flex w-[221px] h-[97px] p-[9px_0px_12px_11px] flex-col justify-center items-start gap-2 m-[10px] rounded-[8px] border border-[#ebebeb] bg-white shadow-[0px_3px_0px_0px_rgba(0,0,0,0.1)]"
                >
                  {!folder.default && (
                    <button
                      className="absolute top-2 right-2"
                        onClick={(e) => {
                        e.stopPropagation();
                        handleEditFolder(folder, index);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          d="M7 7.5H6C5.46957 7.5 4.96086 7.71071 4.58579 8.08579C4.21071 8.46086 4 8.96957 4 9.5V18.5C4 19.0304 4.21071 19.5391 4.58579 19.9142C4.96086 20.2893 5.46957 20.5 6 20.5H15C15.5304 20.5 16.0391 20.2893 16.4142 19.9142C16.7893 19.5391 17 19.0304 17 18.5V17.5"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M16 5.50011L19 8.50011M20.385 7.08511C20.7788 6.69126 21.0001 6.15709 21.0001 5.60011C21.0001 5.04312 20.7788 4.50895 20.385 4.11511C19.9912 3.72126 19.457 3.5 18.9 3.5C18.343 3.5 17.8088 3.72126 17.415 4.11511L9 12.5001V15.5001H12L20.385 7.08511Z"
                          stroke="black"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  )}
                  <span className="text-[32px] font-semibold">
                    {folder.numberOfSuppliers}
                  </span>
                  {folder.name}
                </div>
              ))}

              <div
                onClick={() => setShowModal(true)}
                className="flex w-[221px] h-[97px] p-[9px_0px_12px_11px] flex-col justify-center items-start gap-2 m-[10px] rounded-[8px] border border-[#ebebeb] bg-white shadow-[0px_3px_0px_0px_rgba(0,0,0,0.1)]"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 27 27"
                  fill="none"
                >
                  <path
                    d="M14.625 21.375C14.625 21.7575 14.67 22.1287 14.7262 22.5H4.5C3.90326 22.5 3.33097 22.2629 2.90901 21.841C2.48705 21.419 2.25 20.8467 2.25 20.25V6.75C2.25 5.50125 3.25125 4.5 4.5 4.5H11.25L13.5 6.75H22.5C23.0967 6.75 23.669 6.98705 24.091 7.40901C24.5129 7.83097 24.75 8.40326 24.75 9V15.5363C24.0637 15.1425 23.31 14.8725 22.5 14.7262V9H4.5V20.25H14.7262C14.67 20.6213 14.625 20.9925 14.625 21.375ZM22.5 20.25V16.875H20.25V20.25H16.875V22.5H20.25V25.875H22.5V22.5H25.875V20.25H22.5Z"
                    fill="#7B7B7B"
                  />
                </svg>
                <span className="font-medium text-base text-[#7B7B7B]">
                  Add a new folder
                </span>
              </div>
            </>
          )}
        </div>

        {showModal && (
          <div className="fixed inset-0 z-[1001] flex items-center justify-center">
            <Overlay onClose={() => setShowModal(false)} />

            <div className="relative z-[1002] bg-white p-6 rounded-xl shadow-lg w-full max-w-2xl">
              <div className="flex flex-row justify-between items-center mb-16">
                <h3 className="text-[#1D2739] text-xl font-semibold">
                  {isEditMode ? "Edit Folder" : "Create Folder"}
                </h3>
                <button
                  type="button"
                  className="text-red-500 text-base font-semibold p-2 bg-[#FFF3F3] rounded flex flex-row gap-1 justify-center items-center"
                  onClick={() => {
                    handleDeleteFolder();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                  >
                    <path
                      d="M9.82667 6.49937L9.596 12.4994M6.404 12.4994L6.17333 6.49937M12.8187 4.35937C13.0467 4.39404 13.2733 4.43071 13.5 4.47004M12.8187 4.35937L12.1067 13.6147C12.0776 13.9915 11.9074 14.3435 11.63 14.6002C11.3527 14.8569 10.9886 14.9995 10.6107 14.9994H5.38933C5.0114 14.9995 4.64735 14.8569 4.36999 14.6002C4.09262 14.3435 3.92239 13.9915 3.89333 13.6147L3.18133 4.35937M12.8187 4.35937C12.0492 4.24305 11.2758 4.15477 10.5 4.09471M3.18133 4.35937C2.95333 4.39337 2.72667 4.43004 2.5 4.46937M3.18133 4.35937C3.95076 4.24305 4.72416 4.15477 5.5 4.09471M10.5 4.09471V3.48404C10.5 2.69737 9.89333 2.04137 9.10667 2.0167C8.36908 1.99313 7.63092 1.99313 6.89333 2.0167C6.10667 2.04137 5.5 2.69804 5.5 3.48404V4.09471M10.5 4.09471C8.83581 3.96609 7.16419 3.96609 5.5 4.09471"
                      stroke="#FF0000"
                      stroke-width="1.11111"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Delete folder
                </button>
              </div>

              {isDeleteTriggered ? (
                <>
                  <p className="text-base font-bold text-left">
                    Are you sure you want to delete this folder?
                  </p>
                  <p style={{ color: "#7B7B7B", textAlign: "left" }}>
                    Deleting this folder will also permanently delete all
                    suppliers inside it. This action cannot be undone.
                  </p>
                </>
              ) : (
                <>
                  <label className="flex text-[#1D2739] text-base font-normal mb-[7px] text-left">
                    Folder name
                  </label>

                  <input
                    type="text"
                    placeholder="Folder Name"
                    className="custom-edit-profile-input"
                    value={newFolderName}
                    onChange={(e) => setNewFolderName(e.target.value)}
                  />
                </>
              )}

              <div className="flex flex-col justify-center items-center gap-3 mt-6">
                <button
                  onClick={
                    isDeleteTriggered
                      ? confirmDelete
                      : isEditMode
                      ? handleConfirmEditFolder
                      : handleSubmitFolder
                  }
                  className="flex w-[432px] h-[56px] p-5 justify-center items-center gap-2 rounded-[13px] bg-[#EAF524]"
                >
                  {isDeleteTriggered
                    ? "Delete"
                    : isEditMode
                    ? "Save Changes"
                    : "Proceed"}
                </button>

                <button
                  onClick={() => {
                    setShowModal(false);
                    setIsEditMode(false);
                    setEditingFolderId(null);
                    setNewFolderName("");
                    setTempFolderName("");
                    setDeleteTriggered(false);
                  }}
                  className="text-[#7E7E7E]"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <CompanyTable
        handleEdit={handleEdit}
        setAllSuppliersActive={setAllSuppliersActive}
        title={title}
        tabs={tabs}
        onTabChange={onTabChange}
        pendingSuppliers={pendingSuppliers}
        isSupplierCreated={isSupplierCreated}
        isSupplierUpdated={isSupplierUpdated}
        isEditableSupplier={isEditableSupplier}
        editableCompany={editableCompany}
        selectedTab={selectedTab}
        selectedFolderName={selectedFolderName}
        isFiltered={isFiltered}
      />

      {isNewSupplierClicked && (
        <div ref={popupContainerRef} style={{ zIndex: "1100" }}>
          <CreateNewSupplierForm
            setNewSupplierClicked={setNewSupplierClicked}
            newSupplier={newSupplier}
            editableCompany={editableCompany}
            setEditableCompany={setEditableCompany}
            setSupplierCreated={setSupplierCreated}
            setEditableSupplier={setEditableSupplier}
            isEditableSupplier={isEditableSupplier}
            setEditPopup={setEditPopup}
            folders={folders}
            setPendingSuppliers={setPendingSuppliers}
            setSupplierUpdated={setSupplierUpdated}
          />
        </div>
      )}

      {isSupplierCreated && (
        <>
          <Overlay />
          <div
            ref={createSupplierRef}
            className="supplier-created-container fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1100]"
          >
            <svg
              className="mb-6"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M24 3C29.5695 3 34.911 5.21249 38.8492 9.15076C42.7875 13.089 45 18.4305 45 24C45 29.5695 42.7875 34.911 38.8492 38.8492C34.911 42.7875 29.5695 45 24 45C18.4305 45 13.089 42.7875 9.15076 38.8492C5.21249 34.911 3 29.5695 3 24C3 18.4305 5.21249 13.089 9.15076 9.15076C13.089 5.21249 18.4305 3 24 3ZM21.384 28.143L16.719 23.475C16.5518 23.3078 16.3532 23.1751 16.1347 23.0846C15.9162 22.9941 15.682 22.9475 15.4455 22.9475C15.209 22.9475 14.9748 22.9941 14.7563 23.0846C14.5378 23.1751 14.3392 23.3078 14.172 23.475C13.8342 23.8128 13.6445 24.2708 13.6445 24.7485C13.6445 25.2262 13.8342 25.6842 14.172 26.022L20.112 31.962C20.2788 32.1301 20.4772 32.2635 20.6957 32.3545C20.9143 32.4456 21.1487 32.4924 21.3855 32.4924C21.6223 32.4924 21.8567 32.4456 22.0753 32.3545C22.2938 32.2635 22.4922 32.1301 22.659 31.962L34.959 19.659C35.1285 19.4925 35.2633 19.294 35.3557 19.0751C35.4481 18.8562 35.4962 18.6211 35.4973 18.3835C35.4984 18.1459 35.4525 17.9105 35.3621 17.6907C35.2718 17.4709 35.1388 17.2712 34.9709 17.1031C34.803 16.935 34.6034 16.8018 34.3838 16.7112C34.1641 16.6206 33.9287 16.5744 33.6911 16.5752C33.4535 16.576 33.2184 16.6239 32.9994 16.716C32.7804 16.8081 32.5817 16.9427 32.415 17.112L21.384 28.143Z"
                fill="#0088FF"
              />
            </svg>
            <span>Supplier Created</span>
          </div>
        </>
      )}
      {isEditPopup && (
        <>
          <Overlay />
          <div
            ref={editSupplierRef}
            className="supplier-created-container fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[1100]"
          >
            <svg
              className="mb-6"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M24 3C29.5695 3 34.911 5.21249 38.8492 9.15076C42.7875 13.089 45 18.4305 45 24C45 29.5695 42.7875 34.911 38.8492 38.8492C34.911 42.7875 29.5695 45 24 45C18.4305 45 13.089 42.7875 9.15076 38.8492C5.21249 34.911 3 29.5695 3 24C3 18.4305 5.21249 13.089 9.15076 9.15076C13.089 5.21249 18.4305 3 24 3ZM21.384 28.143L16.719 23.475C16.5518 23.3078 16.3532 23.1751 16.1347 23.0846C15.9162 22.9941 15.682 22.9475 15.4455 22.9475C15.209 22.9475 14.9748 22.9941 14.7563 23.0846C14.5378 23.1751 14.3392 23.3078 14.172 23.475C13.8342 23.8128 13.6445 24.2708 13.6445 24.7485C13.6445 25.2262 13.8342 25.6842 14.172 26.022L20.112 31.962C20.2788 32.1301 20.4772 32.2635 20.6957 32.3545C20.9143 32.4456 21.1487 32.4924 21.3855 32.4924C21.6223 32.4924 21.8567 32.4456 22.0753 32.3545C22.2938 32.2635 22.4922 32.1301 22.659 31.962L34.959 19.659C35.1285 19.4925 35.2633 19.294 35.3557 19.0751C35.4481 18.8562 35.4962 18.6211 35.4973 18.3835C35.4984 18.1459 35.4525 17.9105 35.3621 17.6907C35.2718 17.4709 35.1388 17.2712 34.9709 17.1031C34.803 16.935 34.6034 16.8018 34.3838 16.7112C34.1641 16.6206 33.9287 16.5744 33.6911 16.5752C33.4535 16.576 33.2184 16.6239 32.9994 16.716C32.7804 16.8081 32.5817 16.9427 32.415 17.112L21.384 28.143Z"
                fill="#0088FF"
              />
            </svg>
            <span>Supplier details edited</span>
          </div>
        </>
      )}
    </div>
  );
};
export default Suppliers;
